import { type ChakraProps, Text, VStack } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import { MaskIcon } from '@ui/components/MaskIcon';
import { useTranslations } from 'next-intl';

export const TokenListEmpty = (props: ChakraProps) => {
  const t = useTranslations();
  return (
    <VStack {...props}>
      <MaskIcon
        icon={`url(${getAssetUrl('/masks/error.svg')})`}
        boxSize="64px"
        bg="brand.error"
      />
      <Text textAlign="center">
        {t('card.Only listed tokens on VVS will be shown')}
      </Text>
    </VStack>
  );
};
